import { Field } from 'formik'
import React, { useState, useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageUploadModal from '../../helpers/image-upload';
import axios from "axios";
import { getToken } from '../../helpers/Jwt';

const InputTextareaRich = ({ attr, onChange, value }) => {

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_IMAGE_TEMP = "api/kejati/dashboard/news/upload";

    const [content, setContent] = useState(value);

    const [imgValue, setImgValue] = useState("");
    const [openCropImage, setOpenCropImage] = useState(false);

    const handleChange = (value) => {
        setContent(value);
        if (onChange) {
            onChange(value);
        }
    };

    const handleFotoChange = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            setImgValue(reader.result);
            setOpenCropImage(true);
        };
        reader.readAsDataURL(file);
    };

    const closeModal = () => {
        setOpenCropImage(false);
    };

    const handleCropImage = async (croppedImage) => {
        setOpenCropImage(false);
        try {
            const response = await axios.post(`${BASE_URL}${PATH_IMAGE_TEMP}`, {
                'image': croppedImage
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                }
            });


            const imgTag = `<img src="${BASE_URL}${response.data}" />`;
            setContent((prevContent) => prevContent + imgTag);
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    const modules = useMemo(() => ({
        toolbar: {
            container: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["image"],
            ],
            handlers: {
                image: function () {
                    const input = document.createElement("input");
                    input.setAttribute("type", "file");
                    input.setAttribute("accept", "image/*");
                    input.click();
                    input.onchange = handleFotoChange;
                },
            },
        },
    }), []);

    return (
        <div className='flex-1 my-3 px-2'>
            {value}
            <label htmlFor={attr.name}>{attr.placeholder}</label>
            <Field
                name={attr.name}
                type="hidden"
            />

            <ReactQuill
                theme="snow"
                modules={modules}
                value={content}
                onChange={handleChange}
                className="bg-white"
            />
            <ImageUploadModal
                modalOpen={openCropImage}
                onClose={closeModal}
                fileOpen={imgValue}
                onCroped={handleCropImage}
                imgHeight={200}
                imgWidth={200}
                identifier="logo"
            />
        </div>
    )
}

export default InputTextareaRich;